// extracted by mini-css-extract-plugin
module.exports = {"toggle":"menu-toggle-button_toggle__97Qi9","active":"menu-toggle-button_active__pjkK9"};